import React, { CSSProperties } from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import { MenuItem } from "@mui/material";
import FormSelect from "../../../../../../components/Forms/FormSelect";

function JSVisibility({ name, required }: JSInputProps) {
  const options: { value: CSSProperties["visibility"] | ""; explanation: string }[] = [
    { value: "", explanation: "Visible" },
    { value: "collapse", explanation: "Hidden" },
  ];
  return (
    <FormSelect
      name={name}
      nullable={true}
      options={options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.explanation}
        </MenuItem>
      ))}
      rules={{ required }}
    />
  );
}

export const JSVisibilityComponent: JSInputComponent = {
  Component: JSVisibility,
  handlesCssProperties: ["visibility"],
};
